import React from 'react';
import { AlertTriangle, Ban, Clock, CheckCircle } from 'lucide-react';

export default function UserSuspensionBadge({ user, size = 'sm' }) {
  if (!user) return null;

  const isBanned = user.is_permanently_banned === 1;
  const isSuspended = user.suspended_until && new Date(user.suspended_until) > new Date();

  if (isBanned) {
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full bg-red-100 text-red-700 font-medium ${
        size === 'sm' ? 'text-xs' : 'text-sm'
      }`}>
        <Ban className="w-3 h-3" />
        Banido
      </span>
    );
  }

  if (isSuspended) {
    const daysLeft = Math.ceil((new Date(user.suspended_until) - new Date()) / (1000 * 60 * 60 * 24));
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full bg-orange-100 text-orange-700 font-medium ${
        size === 'sm' ? 'text-xs' : 'text-sm'
      }`}>
        <Clock className="w-3 h-3" />
        Suspenso ({daysLeft}d)
      </span>
    );
  }

  if (user.warning_count > 0) {
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full bg-yellow-100 text-yellow-700 font-medium ${
        size === 'sm' ? 'text-xs' : 'text-sm'
      }`}>
        <AlertTriangle className="w-3 h-3" />
        {user.warning_count} advertência{user.warning_count !== 1 ? 's' : ''}
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full bg-green-100 text-green-700 font-medium ${
      size === 'sm' ? 'text-xs' : 'text-sm'
    }`}>
      <CheckCircle className="w-3 h-3" />
      Normal
    </span>
  );
}